import { render, staticRenderFns } from "./WorkspaceChatSettings.vue?vue&type=template&id=eb728594&scoped=true"
import script from "./WorkspaceChatSettings.vue?vue&type=script&lang=js"
export * from "./WorkspaceChatSettings.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceChatSettings.vue?vue&type=style&index=0&id=eb728594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb728594",
  null
  
)

export default component.exports